import React, { useState, useEffect } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, Card, Badge, DropdownItem, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, UncontrolledTooltip, Alert, Spinner } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PaginationComponent,
    Row,
    Col,
    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableRow,
    DataTableItem,
} from "../../../components/Component";
import { Link } from "react-router-dom";
import { loginAxios } from '../../../config/axios.config';
import { useQuery, useMutation } from "@tanstack/react-query";
import { useSelector, useDispatch } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import './style.scss';

import SingleBarChart from './BarChart';
import NewPieChart from './NewPieChart';
import PieChartPro from './PieChartPro';
import StackedBarChartPro from './StackedBarChartPro';
import StackedBarChartProB from './StackedBarChartProB';
import StackedBarChartProGroup from './StackedBarChartProGroup';
import StackedBarChartProReverseGroup from './StackedBarChartProReverseGroup';
import axios from "axios";

const ChartsDashboard = () => {


    const [RevenueData, setRevenueData] = useState({});
    const [inwardData, setInwardData] = useState({});
    

    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(20);
    const [totalCount, setTotalCount] = useState('');

    const [totalRevenueData, setTotalRevenueData] = useState([]);
    const [totalQtyPieData, setTotalQtyPieData] = useState([]);

    const [inwardChartData, setInwardChartData] = useState([]);
    const [QCChartData, setQCChartData] = useState([]);

    const [productRevenueData, setProductRevenueData] = useState([]);

    const [returnCancelData, setReturnCancelData] = useState({});

    const paginate = (pageNumber) => setCurrentPage(pageNumber);




    const indexOfLastItem = currentPage * itemPerPage;
    const indexOfFirstItem = indexOfLastItem - itemPerPage;



    useEffect(async () => {

        const indexOfLastItem = currentPage * itemPerPage;
        const indexOfFirstItem = indexOfLastItem - itemPerPage;

        var payload = {
            offsetItem: indexOfFirstItem,
            itemPerPage
        }

        // refetchRevenueData.mutate(payload)
        refetchInwardData.mutate();
        // returnCancelAPICall.mutate();
        // purchaseOrderAPICall.mutate();
    }, [itemPerPage, currentPage]);


    const getRevenuesData = async (param) => {
        try {
            const { data } = await loginAxios.get(`dashboard/order-revenue`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken'),
                    'Access-Control-Allow-Origin': '*'
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };
    
    const refetchRevenueData = useMutation(getRevenuesData, {        
        onSettled(data, error) {
            if (data) {
                console.log(data?.data?.finalResponse);
                setRevenueData(data?.data?.finalResponse)
            }
        }
    })



    const getInwardData = async (param) => {
        try {
            const { data } = await loginAxios.get(`dashboard/order-inward`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken'),
                    'Access-Control-Allow-Origin': '*'
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };
    
    const refetchInwardData = useMutation(getInwardData, {        
        onSettled(data, error) {
            if (data) {
                console.log(data?.data?.finalResponse);
                setInwardData(data?.data?.finalResponse)
            }
        }
    })



    const purchaseOrderAPI = async (param) => {
        try {
            const { data } = await loginAxios.get(`dashboard/purchase-order`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken'),
                    'Access-Control-Allow-Origin': '*'
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    
    const purchaseOrderAPICall = useMutation(purchaseOrderAPI, {        
        onSettled(data, error) {
            if (data) {
                console.log(data?.data);
                // setReturnCancelData(data?.data?.finalResponse)
            }
        }
    });





    // const returnCancelAPI = async (param) => {
    //     try {
    //         const { data } = await loginAxios.get(`dashboard/order-return-cancel`, {
    //             headers: {
    //                 'x-auth-token': localStorage.getItem('accessToken'),
    //                 'Access-Control-Allow-Origin': '*'
    //             }
    //         });
    //         return data;
    //     } catch (error) {
    //         return Promise.reject(error);
    //     }
    // };

    
    // const returnCancelAPICall = useMutation(returnCancelAPI, {        
    //     onSettled(data, error) {
    //         if (data) {
    //             console.log(data?.data?.finalResponse);
    //             setReturnCancelData(data?.data?.finalResponse)
    //         }
    //     }
    // })




    // useEffect(() => {
    //     if(RevenueData?.revenue_array?.length > 0) {
    //       let totalRev = RevenueData?.revenue_array.map(item => {
    //         return {
    //           name: item.rev_type,
    //           value: item.tot_rev
    //         };
    //       });
    //       setTotalRevenueData(totalRev);
    //     }
    //     if(RevenueData?.revenue_array?.length > 0) {
    //       let totalRev = RevenueData?.revenue_array.map(item => {
    //         return {
    //           name: item.rev_type,
    //           value: item.tot_qty
    //         };
    //       });
    //       setTotalQtyPieData(totalRev);
    //     }
    //   }, [RevenueData]);




    useEffect(() => {
        if(inwardData?.inward_resp?.length > 0) {
          let collectArr = inwardData?.inward_resp.map(item => {
            return {
              name: item.ship_date,
              data1: item.totalItems,
              data1Lable: 'Total Items'
            };
          });
          console.log(collectArr);
          setInwardChartData(collectArr);
        }
        if(inwardData?.qc_fail_rtv?.length > 0) {
            let collectArr = inwardData?.qc_fail_rtv.map(item => {                
              return {
                name: item.order_month,
                data1: item.total_items_post_cancellation,
                data1Lable: 'Total Items Post Cancellation'
              };
            });
            console.log(collectArr);
            setQCChartData(collectArr);
          }
      }, [inwardData]);


    return (<>
        
        <Head title="Charts"></Head>
        
        <Content>            
            <BlockHead size="sm">
                <BlockBetween>
                    <BlockHeadContent>
                        <BlockTitle>Charts</BlockTitle>
                    </BlockHeadContent>
                </BlockBetween>
            </BlockHead>

            <Block>
                <Row>
                

                {/* <Col md="12">
                    <Card className="card-stretch mt-2  p-3">
                        <h5 style={{textDecoration: 'underline'}}>Stacked Chart - 1</h5>
                        {returnCancelAPICall?.isLoading ? 
                        <div style={{textAlign: 'center'}}>                            
                            <Spinner size="xl" color="light" />
                        </div>                    
                    :   <div className="card-inner-group">
                            <StackedBarChartProGroup chartData={returnCancelData?.groupedData || []} />                                
                        </div>                        
                    }
                    </Card>
                </Col>

                <Col md="12">
                    <Card className="card-stretch mt-2  p-3">
                        <h5 style={{textDecoration: 'underline'}}>Stacked Chart - 2</h5>
                        {returnCancelAPICall?.isLoading ? 
                        <div style={{textAlign: 'center'}}>                            
                            <Spinner size="xl" color="light" />
                        </div>                    
                    :   <div className="card-inner-group">
                            <StackedBarChartProReverseGroup chartData={returnCancelData?.reverseGroupedData || []} />                                
                        </div>                        
                    }
                    </Card>
                </Col> */}

                <Col md="12">
                        <Card className="card-stretch mt-2  p-3">
                        <h5 style={{textDecoration: 'underline'}}>Total Inward</h5>
                            <div className="card-inner-group">
                                <StackedBarChartPro data={inwardData?.inward_delay} />                                
                            </div>
                        </Card>
                    </Col>



                    {/* <Col md="12">
                        <Card className="card-stretch mt-2  p-3">
                        <h5 style={{textDecoration: 'underline'}}>Total Inward</h5>
                            <div className="card-inner-group">
                                <StackedBarChartProB data={inwardData?.inward_delay} />                                
                            </div>
                        </Card>
                    </Col> */}

                    

                    {/* <Col md="6">
                        <Card className="card-stretch mt-2  p-3">
                        <h5 style={{textDecoration: 'underline'}}>Total Inward</h5>
                            <div className="card-inner-group">
                                <SingleBarChart data={inwardChartData} />                                
                            </div>
                        </Card>
                    </Col> */}

                    {/* <Col md="6">
                        <Card className="card-stretch mt-2  p-3">
                        <h5 style={{textDecoration: 'underline'}}>Total QC</h5>
                            <div className="card-inner-group">
                                <SingleBarChart data={QCChartData} />                                
                            </div>
                        </Card>
                    </Col> */}


                    <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Total Revenue</h5>
                            <div className="card-inner-group">                        
                                <PieChartPro mapData={totalRevenueData || []} total="13525" />
                            </div>
                        </Card>
                    </Col>


                    {/* <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Total Quantity</h5>
                            <div className="card-inner-group">                        
                                <PieChartPro mapData={totalQtyPieData || []}  total="4"/>
                            </div>
                        </Card>
                    </Col> */}

                    <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Inward Delay</h5>
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">Month</th>
                                        <th scope="col">Total Items</th>
                                        <th scope="col">Inwarded</th>
                                        <th scope="col">Inwarded Delayed</th>
                                        <th scope="col">1-5 days Delay</th>
                                        <th scope="col">6-10 days Delay</th>
                                        <th scope="col">11-20 days Delay</th>                                        
                                        <th scope="col">Delay Above 20 Days</th>
                                        
                                        

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {inwardData?.inward_delay?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data?.order_month}</td>    
                                                <td>{data?.total_items_post_cancellation}</td>    
                                                <td>{data?.inwarded}</td>    
                                                <td>{data?.inwarded_delayed}</td>    
                                                <td>{data["1_to_5days_delayed"]}</td>      
                                                <td>{data["6_to_10_days_delay"]}</td>                                                     
                                                <td>{data["11_to_20_days_delay"]}</td>      
                                                <td>{data["morethan20_days_delay"]}</td>                                            
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </Card>
                    </Col>


                    <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Pending Delay</h5>
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">1-5 days Delay</th>
                                        <th scope="col">6-10 days Delay</th>
                                        <th scope="col">11-20 days Delay</th>
                                        <th scope="col">Delay Above 20 Days</th>
                                        
                                        
                                        

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {inwardData?.pending_delay?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data["1_to_5days_delayed"]}</td>        
                                                <td>{data["6_to_10_days_delay"]}</td>  
                                                <td>{data["11_to_20_days_delay"]}</td>      
                                                                                                                                           
                                                <td>{data["pending"]}</td>     
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </Card>
                    </Col>

                    <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>QC Fail Items</h5>
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">Month</th>
                                        <th scope="col">Total Items</th>
                                        <th scope="col">Inwarded</th>
                                        <th scope="col">QC Fail</th>
                                        <th scope="col">RTV Items</th>
                                        {/* <th scope="col">QC Fail %</th> */}
                                        {/* <th scope="col">Inwarded</th>                                                                                                                         */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {inwardData?.qc_fail_rtv?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data?.order_month}</td>    
                                                <td>{data?.total_items_post_cancellation}</td>    
                                                <td>{data["inwarded"]}</td>   
                                                <td>{data["qc_fail"]}</td>   
                                                <td>{data?.rtv_items}</td>                                                   
                                                {/* <td>{data?.inwarded}</td>                                                       */}
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </Card>
                    </Col>

                    {/* <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Total Revenue</h5>
                            <div className="card-inner-group">                        
                                <NewPieChart mapData={totalRevenueData || []} />
                            </div>
                        </Card>
                    </Col>



                    <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Total Quantity</h5>
                            <div className="card-inner-group">                        
                                <NewPieChart mapData={totalQtyPieData || []} />
                            </div>
                        </Card>
                    </Col> */}


                    

                    {/* <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Products</h5>
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">Product ID</th>
                                        <th scope="col">Product Revenue</th>
                                        <th scope="col">Total Revenue</th>
                                        <th scope="col">Total Qty.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {RevenueData?.product_array?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data?.productID}</td>    
                                                <td>{data?.prodRev}</td>    
                                                <td>{data?.revTotal}</td>   
                                                <td>{data?.qtyTotal}</td>                                                              
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </Card>
                    </Col>


                    

                    <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Category</h5>
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">Category</th>
                                        <th scope="col">Category Qty.</th>
                                        <th scope="col">Category Revenue</th>
                                        <th scope="col">Qty. %</th>
                                        <th scope="col">Qty. Total</th>
                                        <th scope="col">Rev. %</th>
                                        <th scope="col">Rev. Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {RevenueData?.category_array?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data?.cat}</td>    
                                                <td>{data?.catQty}</td>    
                                                <td>{data?.catRev}</td>   
                                                <td>{data?.qtyPercent}</td>      
                                                <td>{data?.qtyTotal}</td>        
                                                <td>{data?.revPercent}</td>      
                                                <td>{data?.revTotal}</td>                                                              
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </Card>
                    </Col> */}


                    {/* <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Product Revenue</h5>
                            <div className="card-inner-group">                        
                                <NewPieChart mapData={productRevenueData} />
                            </div>
                        </Card>
                    </Col> */}
{/* 
                    <Col md="6">
                        <Card className="card-stretch mt-2">
                            <div className="card-inner-group p-3">                        
                                <NewPieChart mapData={RevenueDataTemp} />
                            </div>
                        </Card>
                    </Col> */}

                </Row>
            </Block>
        </Content>
        <ToastContainer />
    </>)
};

export default ChartsDashboard;